/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A liquid boils when its vapor pressure equals the surrounding pressure. Lower the pressure and that happens at a lower temperature.`)
};

const es_bp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un líquido hierve cuando su presión de vapor iguala a la presión del entorno. Al bajar la presión, esto ocurre a una temperatura menor.`)
};

const de_bp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Flüssigkeit siedet, wenn ihr Dampfdruck dem Umgebungsdruck entspricht. Senkt man den Druck, geschieht das bereits bei niedrigerer Temperatur.`)
};

const nl_bp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een vloeistof kookt wanneer de dampspanning gelijk is aan de omgevingsdruk. Verlaag de druk en dat gebeurt bij een lagere temperatuur.`)
};

const fr_bp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un liquide bout lorsque sa pression de vapeur égale la pression ambiante. En abaissant la pression, cela se produit à une température plus basse.`)
};

const it_bp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un liquido bolle quando la sua tensione di vapore eguaglia la pressione circostante. Abbassando la pressione, ciò avviene a una temperatura inferiore.`)
};

const pt_br2_bp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um líquido ferve quando sua pressão de vapor se iguala à pressão ao redor. Ao diminuir a pressão, isso acontece em uma temperatura mais baixa.`)
};

const pt_bp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um líquido ferve quando a sua pressão de vapor iguala a pressão envolvente. Ao reduzir a pressão, isso acontece a uma temperatura mais baixa.`)
};

const ja_bp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`液体は蒸気圧が周囲の圧力と等しくなったときに沸騰します。圧力を下げると、より低い温度でこの状態に達します。`)
};

const zh_bp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`液体的蒸气压等于周围压力时便会沸腾。降低压力，这一状态会在更低的温度下出现。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_faq_a1", locale)
	if (locale === "en") return en_bp_faq_a1(inputs)
	if (locale === "es") return es_bp_faq_a1(inputs)
	if (locale === "de") return de_bp_faq_a1(inputs)
	if (locale === "nl") return nl_bp_faq_a1(inputs)
	if (locale === "fr") return fr_bp_faq_a1(inputs)
	if (locale === "it") return it_bp_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_bp_faq_a1(inputs)
	if (locale === "pt") return pt_bp_faq_a1(inputs)
	if (locale === "ja") return ja_bp_faq_a1(inputs)
	return zh_bp_faq_a1(inputs)
};